<template>
  <layout title="Kontakt" :banner="$page.props.banner" h1="Kontakt" metaDescription="Hast du Fragen zu deiner Skireise? Du kannst uns ganz einfach anrufen +49 (0) 4435 96000 oder über unser Kontaktformular erreichen. Vielen Dank für deine Anfrage." metaKeywords="SCOL, SCOL Skireisen, Skireise Hilfe, Hilfe Buchung, Reise buchen, Skireise buchen, Skifahren, Ski, Skiurlaub, Frage Buchung">
    <section id="kontakt" class="scol-section bg-light">
      <div class="container-fluid py-sm-4 py-md-0">
        <div class="text-center">
          <h2 class="h3">Noch Fragen? - wir haben die Antworten!</h2>
        </div>
      </div>
    </section>
    <section id="contactform" class="scol-section">
      <div class="scol-section-caption">
        <h2>Kontaktformular</h2>
      </div>
      <div class="container container-small">
        <div class="row justify-content-center">
          <div class="col-12">
            <div v-if="form.feedback.show" class="text-center">
              <div class="alert alert-success" role="alert">
                {{ form.feedback.message }}
              </div>
            </div>
            <form id="contactform-form" v-if="form.show" @submit.prevent="submit()">
              <input type="text" v-model="form.hp1" class="form-control rounded-0" style="position:absolute;left:-10000px;" />
              <input type="text" v-model="form.hp2" class="form-control rounded-0" style="position:absolute;left:-10000px;" />
              <div class="row">
                <div class="col-sm-6 mb-3 form-floating">
                  <div
                    class="form-floating"
                    :class="{ 'is-invalid': form.errors.anrede }"
                  >
                    <select
                      class="form-select rounded-0"
                      :class="{ 'is-invalid': form.errors.anrede }"
                      id="floatingSelect"
                      v-model="form.anrede"
                    >
                      <option value="herr">Herr</option>
                      <option value="frau">Frau</option>
                      <option value="divers">Divers</option>
                    </select>
                    <label for="floatingSelect">Anrede</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.anrede">
                    {{ form.errors.anrede }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.vorname }"
                  >
                    <input
                      type="text"
                      v-model="form.vorname"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.vorname }"
                      id="floatingVorname"
                      placeholder="Vorname"
                    />
                    <label for="floatingVorname">Vorname*</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.vorname">
                    {{ form.errors.vorname }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.nachname }"
                  >
                    <input
                      type="text"
                      v-model="form.nachname"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.nachname }"
                      id="floatingNachname"
                      placeholder="Nachname"
                    />
                    <label for="floatingNachname">Nachname*</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.nachname">
                    {{ form.errors.nachname }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="form-floating"
                    :class="{ 'is-invalid': form.errors.firma }"
                  >
                    <input
                      type="text"
                      v-model="form.firma"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.firma }"
                      id="floatingFirma"
                      placeholder="Firma"
                    />
                    <label for="floatingFirma">Firma</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.firma">
                    {{ form.errors.firma }}
                  </div>
                </div>
              </div>
              <div class="py-4">
                <hr />
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.email }"
                  >
                    <input
                      type="email"
                      v-model="form.email"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.email }"
                      id="floatingE-Mail"
                      placeholder="E-Mail"
                    />
                    <label for="floatingE-Mail">E-Mail*</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.email">
                    {{ form.errors.email }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.telefon }"
                  >
                    <input
                      type="text"
                      v-model="form.telefon"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.telefon }"
                      id="floatingTelefon"
                      placeholder="Telefon"
                    />
                    <label for="floatingTelefon">Telefon</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.telefon">
                    {{ form.errors.telefon }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.strasse }"
                  >
                    <input
                      type="text"
                      v-model="form.strasse"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.strasse }"
                      id="floatingStraße"
                      placeholder="Straße"
                    />
                    <label for="floatingStraße">Straße</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.strasse">
                    {{ form.errors.strasse }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3"
                    :class="{ 'is-invalid': form.errors.hausnummer }"
                  >
                    <input
                      type="text"
                      v-model="form.hausnummer"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.hausnummer }"
                      id="floatingHausnummer"
                      placeholder="Hausnummer"
                    />
                    <label for="floatingHausnummer">Hausnummer</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.hausnummer">
                    {{ form.errors.hausnummer }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-3 mb-sm-0"
                    :class="{ 'is-invalid': form.errors.plz }"
                  >
                    <input
                      type="text"
                      v-model="form.plz"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.plz }"
                      id="floatingPLZ"
                      placeholder="PLZ"
                    />
                    <label for="floatingPLZ">PLZ</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.plz">
                    {{ form.errors.plz }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-floating mb-0"
                    :class="{ 'is-invalid': form.errors.ort }"
                  >
                    <input
                      type="text"
                      v-model="form.ort"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.ort }"
                      id="floatingOrt"
                      placeholder="Ort"
                    />
                    <label for="floatingOrt">Ort</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.ort">
                    {{ form.errors.ort }}
                  </div>
                </div>

                <div class="py-4">
                  <hr />
                </div>

                <div class="col-sm-6">
                  <div
                    class="form-floating"
                    :class="{ 'is-invalid': form.errors.gefunden }"
                  >
                    <select
                      class="form-select rounded-0"
                      :class="{ 'is-invalid': form.errors.gefunden }"
                      id="floatingSelect"
                      v-model="form.gefunden"
                    >
                      <option value="social">Instagram / Facebook</option>
                      <option value="internet">Internet</option>
                      <option value="freunde_familie">Freunde &amp; Familie</option>
                      <option value="flyer_plakat_zeitung">
                        Flyer / Plakat / Zeitung
                      </option>
                      <option value="skiurlaub">Skiurlaub</option>
                      <option value="events">Events</option>
                      <option value="sonstiges">Sonstiges</option>
                    </select>
                    <label for="floatingSelect"
                      >Wie hast du uns gefunden?</label
                    >
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.gefunden">
                    {{ form.errors.gefunden }}
                  </div>
                </div>
                <div class="col-sm-6 mt-3 mt-sm-0" v-if="form.gefunden === 'sonstiges'">
                  <div
                    class="form-floating"
                    :class="{ 'is-invalid': form.errors.gefunden_sonstiges }"
                  >
                    <input
                      type="text"
                      v-model="form.gefunden_sonstiges"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.gefunden_sonstiges }"
                      id="floatingGefundenSonstiges"
                      placeholder="Wie genau?"
                    />
                    <label for="floatingGefundenSonstiges">Wie genau?</label>
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="form.errors.gefunden_sonstiges"
                  >
                    {{ form.errors.gefunden_sonstiges }}
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-6">
                  <div
                    class="form-floating"
                    :class="{ 'is-invalid': form.errors.nachricht }"
                  >
                    <textarea
                      v-model="form.nachricht"
                      class="form-control rounded-0"
                      :class="{ 'is-invalid': form.errors.nachricht }"
                      placeholder="Nachricht"
                      id="floatingNachricht"
                      style="height: 150px"
                    ></textarea>
                    <label for="floatingNachricht">Nachricht</label>
                  </div>
                  <div class="invalid-feedback" v-if="form.errors.nachricht">
                    {{ form.errors.nachricht }}
                  </div>
                </div>
              </div>
              <div class="row mt-sm-3">
                <div class="col-sm-6 mt-3 mt-sm-0">
                  <div class="form-check">
                    <input
                      v-model="form.rueckruf"
                      class="form-check-input rounded-0"
                      :class="{ 'is-invalid': form.errors.rueckruf }"
                      type="checkbox"
                      value=""
                      id="flexCheckRueckruf"
                    />
                    <label class="form-check-label" for="flexCheckRueckruf">
                      <small>Ich möchte zurückgerufen werden.</small>
                    </label>
                    <div class="invalid-feedback" v-if="form.errors.rueckruf">
                      {{ form.errors.rueckruf }}
                    </div>
                  </div>

                  <!-- <div class="form-check">
                    <input
                      v-model="form.katalog"
                      class="form-check-input rounded-0"
                      :class="{ 'is-invalid': form.errors.rueckruf }"
                      type="checkbox"
                      value=""
                      id="flexCheckKatalog"
                    />
                    <label class="form-check-label" for="flexCheckKatalog">
                      <small
                        >Ich möchte den Katalog zugeschickt bekommen.</small
                      >
                    </label>
                    <div class="invalid-feedback" v-if="form.errors.katalog">
                      {{ form.errors.katalog }}
                    </div>
                  </div> -->
                </div>

                <div class="py-4">
                  <hr />
                </div>

                <div class="col-12">
                  <div class="form-check">
                    <input
                      v-model="form.datenschutz"
                      class="form-check-input rounded-0"
                      :class="{ 'is-invalid': form.errors.datenschutz }"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      <small
                        >Ich stimme zu, dass die Angaben in dem Anfrageformular
                        inklusive der dort angegebenen Kontaktdaten zwecks
                        Bearbeitung der Anfrage und für den Fall von
                        Anschlussfragen bei uns gespeichert werden. Diese Daten
                        geben wir nicht ohne Ihre Einwilligung weiter.</small
                      >
                    </label>
                    <div
                      class="invalid-feedback"
                      v-if="form.errors.datenschutz"
                    >
                      {{ form.errors.datenschutz }}
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="mt-4 btn btn-primary rounded-pill"
                    :disabled="form.processing"
                  >
                    <i class="far fa-paper-plane"></i> Senden
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>
<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  setup() {
    const form = useForm({
      show: true,
      hp1rel: null,
      hp1: null,
      hp2: null,
      katalog: null,
      rueckruf: null,
      anrede: null,
      firma: null,
      vorname: null,
      nachname: null,
      strasse: null,
      hausnummer: null,
      plz: null,
      ort: null,
      email: null,
      telefon: null,
      gefunden: null,
      gefunden_sonstiges: null,
      nachricht: null,
      datenschutz: null,
      feedback: {
        show: false,
        message: "",
      },
    });

    let randString = Math.random().toString(36).slice(2);
    form.hp1rel = randString;
    form.hp1 = randString;

    const submit = () => {
      form.post(route("contact.store"), {
        onStart: () => {
          form.feedback = {
            show: false,
            message: "",
          };
        },
        onSuccess: () => {
          form.reset();
          form.show = false;
          form.feedback = {
            show: true,
            message: "Deine Anfrage wurde versendet, vielen Dank!",
          };
        },
        onError: () => {
          form.feedback = {
            show: false,
            message: "Deine Anfrage konnte nicht versendet werden.",
          };
        },
      });
    };

    return { form, submit };
  },
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
    useForm,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
